export const isNil = (value) => value === null || value === undefined;

export const toNumber = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const isMissing = (value) => {
  if (isNil(value)) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  return false;
};

export const humanize = (value) => {
  if (isNil(value)) return "";
  const s = String(value)
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!s) return "";
  return s.replace(/\b\w/g, (ch) => ch.toUpperCase());
};

export const coalesce = (obj, keys) => {
  if (!obj) return null;
  for (const key of keys) {
    if (!(key in obj)) continue;
    const v = obj[key];
    if (!isMissing(v)) return v;
  }
  return null;
};

export const normalizeBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (["y", "yes", "true", "1"].includes(s)) return true;
    if (["n", "no", "false", "0"].includes(s)) return false;
  }
  return null;
};

export const formatCurrencyCompact = (value, { currency = "$" } = {}) => {
  const num = toNumber(value);
  if (num === null) return null;

  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1e9) return `${sign}${currency}${(abs / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}${currency}${(abs / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${sign}${currency}${(abs / 1e3).toFixed(1)}K`;
  return `${sign}${currency}${abs.toFixed(0)}`;
};

export const formatPercentCompact = (value) => {
  const num = toNumber(value);
  if (num === null) return null;

  const fraction = num > 1 && num <= 100 ? num / 100 : num;
  const pct = fraction * 100;

  if (pct === 0) return "0%";
  if (pct < 0.01) return "<0.01%";
  if (pct < 1) return `${pct.toFixed(2)}%`;
  if (pct < 10) return `${pct.toFixed(2)}%`;
  return `${pct.toFixed(1)}%`;
};

export const formatScore = (value) => {
  const num = toNumber(value);
  if (num === null) return null;
  return num.toFixed(2);
};

export const formatRange = (low, high) => {
  const lo = formatPercentCompact(low);
  const hi = formatPercentCompact(high);
  if (!lo && !hi) return null;
  if (!lo) return hi;
  if (!hi) return lo;
  return `${lo}–${hi}`;
};

